import { EmergenceAnimation } from '@/app/_common/emergence-loader'
import { cn } from '@/lib/utils'
import { T } from '@tolgee/react'

const LoadingTabContent = ({
  title,
  className,
}: Readonly<{ title: string; className?: string }>) => (
  <div
    className={cn('fixed left-0 top-0 flex h-dvh w-full items-center justify-center', className)}
  >
    <EmergenceAnimation title={title} />
  </div>
)

const ErrorTabContent = ({ className }: Readonly<{ className?: string }>) => (
  <div className={cn('flex h-full w-full items-center justify-center', className)}>
    <p className='w-full text-center text-error-300'>
      <T keyName='shared.error.system' />
    </p>
  </div>
)

export { ErrorTabContent, LoadingTabContent }
